class exports.Account_Handler extends FullPageHandler
    init: () ->
        @sidebar_open = false
        @layoutUrl = 'backend/portal/account/'
        @createDialog()

    afterLoadLayout: () ->
        @openDialog()
